import { Controller } from "@hotwired/stimulus";

// OZ Relayer のガス残高を <dialog> + Turbo Frame で遅延ロードして表示する。
// ギフト配布の reward-modal / row-link パターンを、単体ウィジェット用に1コントローラへ集約したもの。
// アイコンクリックでフレームに src をセット → 取得完了(turbo:frame-load)でモーダルを開く。
export class RelayerBalanceModalController extends Controller {
  static targets = ["dialog", "frame"];
  static values = { url: String };

  // ガスポンプアイコンのクリック。ページ遷移はせず、フレームに残高ページを読み込む。
  open(event) {
    event.preventDefault();
    this.frameTarget.src = this.urlValue;
  }

  // フレームに内容が入ったらモーダルを開く（空のまま開いてチラつくのを防ぐ）。
  show() {
    this.dialogTarget.showModal();
  }

  // 閉じるボタン(data-close-dialog) / バックドロップクリックで閉じる。
  handleClick(event) {
    if (event.target.closest("[data-close-dialog]") || event.target === this.dialogTarget) {
      this.dialogTarget.close();
    }
  }

  // 入金先アドレスをクリップボードにコピー（手打ちによる送金ミス＝資金消失を防ぐ）。
  async copy(event) {
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(button.dataset.address);
      const original = button.textContent;
      button.textContent = "コピーしました";
      setTimeout(() => { button.textContent = original; }, 1500);
    } catch (_e) {
      // クリップボード API が使えない環境では何もしない
    }
  }

  // 閉じたらフレームを空にして src も外す。次回開いたときに残高を再取得して最新化する。
  dialogTargetConnected(element) {
    element.addEventListener("close", () => {
      this.frameTarget.removeAttribute("src");
      this.frameTarget.innerHTML = "";
    });
  }
}
